import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import "./Slide.css";

export const Slide = React.memo(function Slide(props) {
  const {
    data,
    dataIndex,
    isCenterSlide,
    swipeTo,
    slideIndex
  } = props;

  const item = data[dataIndex] || {};
  const { image: coverImage, text, rank, id: imageId } = item;

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const cardClick = () => {
    if (!isCenterSlide) {
      swipeTo(slideIndex); // bring to center first
      return;
    }
    handleOpen(); // open modal only when centered
  };

  return (
    <>
      <div
        className="card-card"
        draggable={false}
        onClick={cardClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") cardClick();
        }}
        style={{ cursor: "pointer" }}
      >
        <div className={`cover fill ${isCenterSlide ? "off" : "on"}`}>
          <div
            className="card-overlay fill"
            onClick={() => {
              if (!isCenterSlide) swipeTo(slideIndex);
            }}
          />
        </div>

        <div className="detail fill justify-content-center">
          <div className="discription justify-content-center">
            <img
              style={{ height: 300, padding: "1rem" }}
              className="cover-image"
              src={coverImage}
              id={imageId}
              alt={text || imageId}
            />
            <h5 className="text-center">{text}</h5>
            {rank && <p className="text-center">{rank}</p>}
          </div>
        </div>
      </div>

      {/* Modal */}
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        aria-labelledby={`slide-dialog-${imageId}`}
      >
        <DialogTitle id={`slide-dialog-${imageId}`} sx={{ pr: 6 }}>
          {text} {rank ? `– ${rank}` : ""}
          <IconButton
            aria-label="Close"
            onClick={handleClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <img
            src={coverImage}
            alt={text || imageId}
            style={{ width: "100%", height: "auto", display: "block" }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
});
